import { CellProps } from '@/components/bulkQueue/types';
import { OrderChip } from '@/components/orders/OrderChip';
import { ExpandableText } from '@/components/text/ExpandableText';
import { Box, Typography } from '@mui/material';
import { FC } from 'react';

export const OrderRenderCell: FC<CellProps> = (props) => {
    const { order } = props.entity;

    if (order) {
        return <OrderChip order={order} />;
    }

    return <Typography fontSize={'14px'}>None</Typography>;
};

export const OrderNotesRenderCell = (props: CellProps) => {
    const { order } = props.entity;

    return (
        <Box sx={{ fontSize: '14px' }}>
            <ExpandableText text={order?.orderNotes ?? null} title='Order Notes' />
        </Box>
    );
};
